
'use strict';

import vex from 'vex-js';
import DateTimePicker from './date-time-picker';

const config = {
    clickEvents: 'click touch',
    closeBtnClass: 'vex-close-btn',
    closeTarget: '.vex-close, .vex-close-btn, .vex-close-link',
    dateTarget: '.js-date-time, .js-date',
    modalContent: '[data-modal="modal"]',
    triggerTarget: '.js-modal',
    openNowClass: 'js-modal-open',
    vexTheme: 'vex-theme-plain no-padding-darker-theme'
};

class DefaultModal {

    constructor() {
        if(!$(config.triggerTarget).length) {
            return;
        }

        this.setupClickEvents();
    }

    /**
     * Sets up all click events for the Modal component
     */
    setupClickEvents() {
        let triggerTarget = $(config.triggerTarget);

        triggerTarget.on(config.clickEvents, (e) => this.handleOpenModal(e));

        triggerTarget.each(function () {
            let current = $(this);

            if (current.hasClass(config.openNowClass)) {
                current.trigger(config.clickEvent);
            }
        });
    }

    /**
     * Handles trigger for opening the modal
     *
     * @param {event} e
     */
    handleOpenModal(e) {
        e.preventDefault();

        let $modalContents = $(e.currentTarget).next(config.modalContent).html();

        this.vex = vex.open({
            content: $modalContents,
            className: config.vexTheme,
            closeClassName: config.closeBtnClass
        });

        $(config.closeTarget, this.vex[0]).on(config.clickEvents, (e) => this.handleCloseDialog(e));

        let dateTimePicker = new DateTimePicker();
        dateTimePicker.initialisePickers($(config.dateTarget));
    }

    /**
     * Handler for when close is clicked
     *
     * @param {event} e
     */
    handleCloseDialog(e) {
        e.preventDefault();

        this.closeDialog();
    }

    /**
     * Closes the dialog associated with this instance
     */
    closeDialog() {
        vex.close(this.vex.data().vex.id);
    }
}

$(window).load(function(){
    new DefaultModal();
});



// WEBPACK FOOTER //
// ./src/js/components/default-modal.js